import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import { setSection } from "../../../assignmentSlice";

import { applyUnderline } from "../../../../../utils/textUtils";

import UserInputBar from "../../widgets/UserInputBar";
import CommonPage from "../../common/CommonPage";

const DescriptiveConditionPage = ({
  section,
  pageList,
  currentPage,
  currentIndex,
  setPageList,
  handlePreviousPage,
  handleNextPage,
}) => {
  const dispatch = useDispatch();

  const [userInput, setUserInput] = useState("");
  const [overlayVisible, setOverlayVisible] = useState(false);

  useEffect(() => {
    if (currentPage.isSubmitted) {
      setUserInput(currentPage.answer);
    } else {
      setUserInput(currentPage.input || "");
    }
  }, [currentIndex]);

  const handleChange = (e) => {
    setUserInput(e.target.value);
  };

  const handleSetAnswer = () => {
    const newPageList = pageList.map((prevPage, index) => {
      if (index === currentIndex) {
        return {
          ...prevPage,
          input: userInput,
        };
      }
      return prevPage;
    });

    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
  };

  const handleSubmit = () => {
    if (currentPage.isSubmitted) return;

    const correct =
      userInput.replace(/[!.,:?]/g, "") ===
      currentPage.answer.replace(/[!.,:?]/g, "");
    const newPageList = pageList.map((page, index) => {
      if (index === currentIndex) {
        return {
          ...page,
          input: userInput,
          isSubmitted: true,
          isCorrect: correct,
        };
      }
      return page;
    });

    setOverlayVisible(true);
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
    setTimeout(() => {
      setOverlayVisible(false);
      setUserInput(currentPage.answer);
    }, 600);
  };

  return (
    <CommonPage
      currentIndex={currentIndex}
      handleNextPage={handleNextPage}
      handlePreviousPage={handlePreviousPage}
      totalNo={pageList.length}
      currentPage={currentPage}
      paragraph={currentPage.text}
      overlayVisible={overlayVisible}
      isCorrect={currentPage.isCorrect}
      handleSubmit={handleSubmit}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
          width: "90%",
        }}
      >
        <div
          style={{
            width: "90%",
            fontSize: "20px",
            marginBottom: "20px",
            textAlign: "left",
          }}
        >
          {applyUnderline(currentPage.question)}
        </div>
        <div
          style={{
            boxSizing: "border-box",
            fontSize: "20px",
            lineHeight: "1.5",
            width: "90%",
            padding: "10px 20px",
            border: "1px solid #000",
          }}
        >
          {"<조건>"} <br />
          {(currentPage.text2 ?? currentPage.condition).split("\n").map((line, index) => (
            <React.Fragment key={index}>
              {line} <br />
            </React.Fragment>
          ))}
        </div>
        <div
          style={{
            boxSizing: "border-box",
            fontSize: "20px",
            lineHeight: "1.5",
            width: "90%",
            padding: "10px 20px",
            border: "1px solid #000",
          }}
        >
          {"<보기>"} <br />
          {currentPage.text3 ?? currentPage.example}
        </div>
        <div style={{ position: "relative", width: "90%", marginTop: "20px" }}>
          <UserInputBar
            handleSetAnswer={handleSubmit}
            handleChange={handleChange}
            userInput={userInput}
            type={"paragraph"}
            onlyUnderline={true}
            isSubmitted={currentPage.isSubmitted}
          />
        </div>
      </div>
    </CommonPage>
  );
};

export default DescriptiveConditionPage;
